import React from "react";
import { Form, FloatingLabel, Row } from "react-bootstrap";
import { ArrowLeft } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";

import { ForgotUIProps } from "./Forgot.types.tsx";

import { SubHeaderLabel, HeaderLabel, GreenLabel } from "../Labels.tsx";
import { ActionButton } from "../Buttons.tsx";

import { useLoginContext } from "../../views/Login/Login.context.tsx";

const ForgotUI: React.FC<ForgotUIProps> = ({ email, validated, handleChange, handleSubmit }) => {
  const { loadingComponent, setCurrentView, isLoading } = useLoginContext();
  const { t } = useTranslation();

  if (isLoading) return loadingComponent;

  return (
    <Row style={{ maxWidth: 400 }} className="mx-auto">
      <HeaderLabel>{t("forgot.forgotPasswordTitle")}</HeaderLabel>
      <SubHeaderLabel>{t("forgot.forgotPasswordDescription")}</SubHeaderLabel>

      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <FloatingLabel controlId="floatingEmail" label={t("forgot.emailLabel")} className="mb-3">
          <Form.Control
            type="email"
            name="email"
            placeholder=""
            value={email}
            onChange={handleChange}
            required
          />
          <Form.Control.Feedback type="invalid">{t("forgot.requiredField")}</Form.Control.Feedback>
        </FloatingLabel>

        <ActionButton type="submit">{t("forgot.sendCode")}</ActionButton>

        <GreenLabel onClick={() => setCurrentView("login")}>
          <ArrowLeft />
          {t("forgot.backToLogin")}
        </GreenLabel>
      </Form>
    </Row>
  );
};

export default ForgotUI;
